import {
  createComponentMapperModel,
  withCompInfo,
} from '@wix/editor-elements-integrations';
import {
  activeFocusRingStyle,
  cssVariables,
  defaultInputDisplay,
} from '../constants';
import {
  ISelectableContainerCarmiProps,
  ISelectableContainerDefinition,
  ISelectableContainerMapperProps,
} from '../types';

export const props = withCompInfo<
  ISelectableContainerMapperProps,
  ISelectableContainerDefinition,
  ISelectableContainerCarmiProps
>()(
  ['compData', 'compStylableClass', 'compMeshProps', 'hasResponsiveLayout'],
  (
    { compData, compStylableClass, compMeshProps, hasResponsiveLayout },
    carmiData,
  ) => ({
    ...carmiData,
    ...compData,
    stylableClassName: compStylableClass,
    meshProps: compMeshProps,
    hasResponsiveLayout,
  }),
);

const css = withCompInfo<any, ISelectableContainerDefinition>()(
  ['styleProperties'],
  ({ styleProperties }) => {
    const { isInputVisible = true } = styleProperties as {
      isInputVisible?: boolean;
    };

    if (isInputVisible) {
      return {
        [cssVariables.inputDisplay]: defaultInputDisplay,
        [cssVariables.containerFocusRing]: 'none',
      };
    }

    return {
      [cssVariables.inputDisplay]: 'none',
      [cssVariables.containerFocusRing]: activeFocusRingStyle,
    };
  },
);

export default createComponentMapperModel({
  props,
  css,
});
